export default {
  schema: {
    title: 'Screen Name',
    type: 'object',
    required: ['richtextRequired'],
    properties: {
      richtext: {
        title: 'My Rich Text',
        type: 'string',
        minLength: 2,
        maxLength: 100
      },
      richtextRequired: {
        title: 'Required Rich Text Field',
        type: 'string',
        minLength: 2,
        maxLength: 100
      },
      org: {
        title: 'Name <i>of</i> Organization in schema',
        type: 'string',
        minLength: 100
      }
    }
  },
  uiSchema: {
    richtext: {
      'ui:widget': 'richtext',
      'ui:description': 'Help text displayed in a tooltip',
      'ui:help': {
        text: 'Help text displayed in a tooltip',
        escape: true
      }
    },
    richtextRequired: {
      'ui:widget': 'richtext'
    },
    'dm:layout': [{
      type: 'field',
      id: 'richtext'
    }, {
      type: 'field',
      id: 'richtextRequired'
    }, {
      type: 'field',
      id: 'org'
    }]
  },
  formData: {}
};